import type { FormatFunction, i18n as II18n } from 'i18next';

import { Duration } from '../Duration';
import { Money } from '../Money';
import { Period } from '../Period';

import { decode } from './decodeFormat';
import { formatDate, formatDuration } from './formatDate';
import { formatMoney, formatNumber } from './formatNumber';
import { formatPeriod } from './formatPeriod';

export const supportedLocales = ['en-GB', 'en-US', 'de-DE'];

export const formatFunction: FormatFunction = function (this: II18n, value, format) {
  const decodedFormat = decode(format);
  if (value instanceof Date) {
    return formatDate(value, decodedFormat);
  }

  if (typeof value === 'number') {
    return formatNumber(value, decodedFormat);
  }

  if (value instanceof Money) {
    return formatMoney(value, decodedFormat);
  }

  if (value instanceof Period) {
    return formatPeriod(this, value);
  }
  if (value instanceof Duration) {
    return formatDuration(value);
  }

  return value;
};
